import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';

import { Status } from 'src/app/core/framework/default.model';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { MyAutocomplete } from 'src/app/core/framework/input-components/my-autocomplete';
import { UnidadeFilter } from 'src/app/farmacia/unidade/unidade.filter';
import { Unidade } from 'src/app/farmacia/unidade/unidade.model';
import { UnidadeService } from 'src/app/farmacia/unidade/unidade.service';
import { PermissaoNome } from 'src/app/seguranca/perfil-de-acesso/permissao/permissao-nome.enum';
import { Usuario } from 'src/app/seguranca/usuario/usuario/usuario.model';
import { UsuarioService } from 'src/app/seguranca/usuario/usuario/usuario.service';


@Component({
  selector: 'app-autocomplete-unidade',
  templateUrl: './autocomplete-unidade.component.html',
  styleUrls: ['./autocomplete-unidade.component.css']
})
export class AutocompleteUnidadeComponent implements OnInit, AfterViewInit, OnDestroy {

  public autocomplete: MyAutocomplete<Unidade>;
  // private unidadeSubscription: Subscription;
  formDisabled = false;
  @Input() obrigatorio = false;
  @Input() placeholder = 'Unidade';
  @Input() bloqueado   = false;
  @Input() exibirLimpar = true;
  @Input() autoSelecionarUnidadeDoUsuario = true;

  constructor(
    private httpClient: HttpClient
    , private errorHandlerService: ErrorHandlerService
    , private usuarioService: UsuarioService
    , private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.carregarDados();
  }

  ngOnDestroy(): void {
    if ( this.autocomplete ) {
      this.autocomplete.destroy();
    }
  }

  ngAfterViewInit(): void {
    const usuarioTemPermissaoParaVerTodasUnidades: boolean = this.usuarioService.usuarioLogadoTemPermissao(PermissaoNome.ROLE_ACESSAR_TODAS_UNIDADES);
    if ( usuarioTemPermissaoParaVerTodasUnidades ) {
      this.exibirLimpar = true;
      this.formDisabled = false;
    }
    else {
      this.formDisabled = true;
      this.exibirLimpar = false;
    }

    if ( this.autoSelecionarUnidadeDoUsuario ) {
      const usuarioLogado: Usuario = UsuarioService.getUsuarioFromLocalStorage();
      if (usuarioLogado.unidade) {
        setTimeout(() => {
          this.autocomplete.selecionarItem(usuarioLogado.unidade);
        }, 100);
      }
    }

    this.changeDetectorRef.detectChanges();
  }

  getMyAutocomplete(): MyAutocomplete<Unidade> {
    return this.autocomplete;
  }

  private carregarDados(): void {
    const unidadeFilter: UnidadeFilter = {
      status: Status.ATIVO
    };

    const autoBuscarItemPorCampo = 'nome';
    this.autocomplete = new MyAutocomplete(
      this.httpClient,
      this.errorHandlerService,
      UnidadeService.url,
      null,
      unidadeFilter,
      autoBuscarItemPorCampo,
      false
    );
  }

}
